import React from "react";
import { useLang } from "../../context/LanguageContext";
import {
  Wifi,
  Wind,
  Bath,
  Tv,
  Ban,
  KeyRound,
  ShoppingBasket,
  DoorOpen,
} from "lucide-react";
import { Reveal } from "./Reveal";

const icons = [Wifi, Wind, Bath, Tv, Ban, KeyRound, ShoppingBasket, DoorOpen];

export const Amenities = () => {
  const { t } = useLang();

  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="relative py-24 md:py-40 bg-stone-900 text-stone-50 overflow-hidden"
    >
      {/* Decorative */}
      <div
        aria-hidden
        className="absolute -top-20 -left-20 w-96 h-96 rounded-full bg-amber-500/5 blur-3xl"
      />
      <div
        aria-hidden
        className="absolute -bottom-20 -right-20 w-96 h-96 rounded-full bg-amber-200/5 blur-3xl"
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-20">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.35em] text-amber-300/90">
              — {t.amenities.overline}
            </span>
          </Reveal>
          <Reveal delay={80}>
            <h2 className="mt-6 font-heading text-5xl md:text-6xl lg:text-7xl leading-[0.98] tracking-tight text-stone-50">
              {t.amenities.title}
            </h2>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-stone-800">
          {t.amenities.items.map((item, i) => {
            const Icon = icons[i % icons.length];
            return (
              <Reveal key={i} delay={60 * i}>
                <div
                  data-testid={`amenity-${i}`}
                  className="bg-stone-900 p-8 md:p-10 min-h-[200px] flex flex-col justify-between group hover:bg-stone-800 transition-colors duration-500"
                >
                  <Icon className="w-7 h-7 text-amber-300/90 stroke-[1.2]" />
                  <div>
                    <h3 className="font-heading text-2xl text-stone-50">
                      {item.title}
                    </h3>
                    <p className="mt-2 text-sm text-stone-400 font-light leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
